export default "/compare-sales-chart.6e948ae9-88943f.png";